import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import SearchContainer from "components/SearchContainer";
import Table from "components/Table";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { ResType } from "types";
import { getAutFinancialYears } from "utils/getFinancialYears";
import { StyledSpan } from "views/atom-pro/styles";
import {
  calculateAssessmentYear,
  clientCategories,
  incomeTaxForms,
  incomeTaxFormsFilingTypes,
  tanFormStats,
  udinFormStats,
} from "./constants";

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import useTitle from "hooks/useTitle";
// import { getOrganizationPreference } from "api/services/common";
import { snack } from "components/toast";
import { getIncomeTaxForms } from "api/services/automation/income-tax-tan";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import { Permissions } from "data/permissons";
import { exportTanIncomeTaxForms } from "api/services/automation/income-tax-tan";
import { getCurrentFormattedDateTime } from "utils";
import { handleError } from "utils/handleError";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import CampaignIcon from "@mui/icons-material/Campaign";
import IncomeTaxTanStatements from "views/atom-pro/incomtaxtanStatements";



const TanIncomeTaxForms = () => {
  useTitle("ATOM Pro | Forms");
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const { permissions } = usePermissions();
  const [openInfo, setOpenInfo] = useState(false);
  

  const [filters, setFilters] = useState<any>({
    formCode: null,
    filingType: null,
    financialYear: null,
    clientCategory: null,
    udinStat: null,
    financialQuarter: null,
  });
  const forms = incomeTaxForms;
  const financialYear = getAutFinancialYears();
  const quarters = ["Q1", "Q2", "Q3", "Q4", "NA"];

  const location = useLocation();
  const state: any = location.state;

  // const { data: incomeTaxAccess, isLoading: isLoadingIncomeTaxAccess }: ResType = useQuery(
  //   ["Income Tax Access Check"],
  //   getOrganizationPreference,
  //   {
  //     onSuccess: (res: any) => {
  //       if (res?.data?.automationConfig?.incomeTax === "YES") {
  //       } else {
  //         snack.error("Please subscribe Atom Pro Income tax");
  //         navigate("/atom-pro/incomeTaxLimit");
  //       }
  //     },
  //     // enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   }
  // );
  let defaultColumns = [
    {
      key: "id",
      title: "Financial Year",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            {row?.refYear ? (
              (
                <Typography> FY {calculateAssessmentYear(row?.refYear)}</Typography>
              )
            ) : (
              "-"
            )}
          </Box>
        );
      },
    },
    {
      key: "financialQuarter",
      title: "Quarter",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
    },

    {
      key: "name",
      title: (
        <Box display="flex" alignItems="center">
          <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} />
          Client Name (TAN)
        </Box>
      ),
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row) => (
        <Typography>
          {row?.tanClientCredentials?.client?.displayName} (<span>{row?.tanClientCredentials?.tanNumber}</span>)
        </Typography>
      ),
    },

    {
      key: "formDesc",
      title: "Form Name",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true
    },
    {
      key: "ackDt",
      title: "Filing Date",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true
    },
    {
      key: "tempAckNo",
      title: "RRR#",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true
    },
    {
      key: "filingTypeCd",
      title: "Filing Type",
      sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => {
        return (
          <Box>
            {row?.filingTypeCd === "Regular" ? (
              <StyledSpan bgColor="#f2e6ff">{row?.filingTypeCd}</StyledSpan>
            ) : (
              <StyledSpan bgColor="#b3ecff">{row?.filingTypeCd}</StyledSpan>
            )}
          </Box>
        );
      },
    },
     {
      key: "status",
      title: "Processing Status",
      render: (row: any) => {
         return (
          <Box>
          {row?.status === "Processed With Defaults" ? (
            <Typography color="#5d1b04ff">{row?.status}</Typography>
          ) : row?.status === "Processed Without Defaults" ? (
            <Typography color="#0e5b2aff">{row?.status}</Typography>
          ) : (
            <Typography >{row?.status ? row?.status : 'NA'}</Typography>
          )}
          </Box>
        );
      },
    },
     {
      key: "dtOfPrcng",
      title: "Date of Processing",
      render: (row: any) => {
        return <Typography>{row?.dtOfPrcng ? row?.dtOfPrcng || "-" : "NA"}</Typography>;
      },
    },
    {
      key: "udinNum",
      title: "UDIN",
      render: (row: any) => {
        return <Typography>{row?.isUdinApplicable ? row?.udinNum || "-" : "NA"}</Typography>;
      },
    },
  ];
  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const { data, isLoading }: ResType = useQuery(
    [
      "income-Tax-Tan-Forms",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        ...filters,
        sort
      },
    ],
    getIncomeTaxForms,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
      // enabled: permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
    }
  );

  useEffect(() => {
    if (state) {
      setFilters({
        ...filters,
        filingType: state?.filingType,
        financialYear: state?.financialYear,
        udinStat: state?.udinType,
        financialQuarter: state?.financialQuarter,
        formCode: state?.formCd
      });
      setPage(0);
    }
  }, [state]);



  const handleRowClick = (v: any) => {
    navigate(`/atom-pro/income-tax-tan/form/${v?.id}`);
  };


  const handleUdinStatChange = (e) => {
    setFilters({ ...filters, udinStat: e.target.value });
    setPage(0);
  };

  const handleformDescChange = (e) => {
    setFilters({ ...filters, formCode: e.target.value });
    setPage(0);
  };

  const handleQuarterChange = (e) => {
    setFilters({ ...filters, financialQuarter: e.target.value });
    setPage(0);
  };

  const handleAssessmentYearChange = (e) => {
    setFilters({ ...filters, financialYear: e.target.value });
    setPage(0);
  };

  const onClientCategoryChange = (e) => {
    setFilters({ ...filters, clientCategory: e.target.value });
    setPage(0);
  };

  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };

  const handleFilingTypeChange = (e) => {
    setFilters({ ...filters, filingType: e.target.value });
    setPage(0);
  };


  const { mutate: mutate1 } = useMutation(exportTanIncomeTaxForms, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - Income Tax Forms ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax Forms exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    mutate1({
      ...state,
      ...filters
    });
  };

  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };

  // if (!(permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS))) {
  //   return <AccessDenied />
  // }

  return (
    <Box m={1}>
      <Box pr={2} pl={2} sx={{ display: "flex" }}>
        <Box display="flex">
          <Box ml={0.5}>
            <TextField
              label="Financial Year"
              value={filters.financialYear || ""}
              sx={{ width: 120 }}
              onChange={handleAssessmentYearChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {financialYear?.map((year, index) => (
                <MenuItem key={index} value={year.split("-")[0]}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box>
            {/* <Box ml={0.5}>
              <TextField
                name="clientCategory"
                value={filters.clientCategory || ""}
                onChange={onClientCategoryChange}
                size="small"
                label="Category"
                select
                sx={{ width: "150px" }}
              >
                <MenuItem key={""} value={""}>
                  Select
                </MenuItem>
                {clientCategories.map((category) => (
                  <MenuItem key={category.value} value={category.value}>
                    {category.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box> */}
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Form Code"
              value={filters.formCode || ""}
              sx={{ width: 120 }}
              onChange={handleformDescChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {forms.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5}>
            <TextField
              label="Quarter"
              value={filters.financialQuarter || ""}
              sx={{ width: 120 }}
              onChange={handleQuarterChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {quarters.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Box ml={0.5} mr={1}>
            <TextField
              label="UDIN Stats"
              value={filters.udinStat || ""}
              sx={{ width: 110 }}
              onChange={handleUdinStatChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {Object.keys(udinFormStats).map((key, index) => (
                <MenuItem key={index} value={key}>
                  {udinFormStats[key]}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box ml={0.5} mr={1}>
            <TextField
              label="Filing Type"
              value={filters.filingType || ""}
              sx={{ width: 110 }}
              onChange={handleFilingTypeChange}
              size="small"
              select
            >
              <MenuItem key={""} value={""}>
                Select
              </MenuItem>
              {tanFormStats.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>

        <SearchContainer
          minWidth="250px"
          value={search}
          debounced
          placeHolder="Search by  Name | TAN"
          onChange={handleSearch}
        />

        <Button
          onClick={() => {
            setFilters({});
            setSearch("");
          }}
          sx={{ marginLeft: "5px", marginRight: "5px" }}
          size="small"
          color="secondary"
          variant="outlined"
        >
          Clear Filters
        </Button>
         <Button onClick={() => setOpenInfo(true)} variant="outlined" sx={{ mr: 3, ml: 3 }}>
          <CampaignIcon />
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}
        >
          Export
        </Button>
        <IncomeTaxTanStatements open={openInfo} setOpen={setOpenInfo} />

      </Box>

      <Box mt={1}>
        <Table
          sx={{ height: '510px' }}
          pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
          data={data?.data.result || []}
          columns={columns}
          sortHandler={handleSort}
          loading={isLoading}
          onRowClick={handleRowClick}
        />
      </Box>
    </Box>
  );
};

export default TanIncomeTaxForms;
